/******************************************************************************************
 *	Renewal Quote Utility Methods
 *******************************************************************************************/
(function() {
  

  angular
    .module('rcServices.renewalQuoteUtility', [])
    // TO DO: make more comprehensive list of currency symbols, if requested by program management
    .constant('CURRENCY_SYMBOLS', {
      AUD: 'A$',
      BRL: 'R$',
      CNY: '¥',
      EUR: '€',
      GBP: '£',
      JPY: '¥',
      KRW: '₩',
      RUB: 'руб',
      USD: '$'
    })
    .service(
      'RenewalQuoteUtility',
      /* @ngInject */
      function(_, CURRENCY_SYMBOLS) {
        var getCurrencySymbol = function(currencyCode) {
          return CURRENCY_SYMBOLS[currencyCode] || currencyCode;
        };

        /*
        * Fields that must match for parts to be aggregated:
        * contractId
        * partNumber
        * productCode
        * productName
        * monthlyRenewalPrice
        * currency
        * priceLockYearsRemaining
        * */
        var shouldPartsBeAggregated = function(part1, part2) {
          return _.isMatch(
            part1,
            _.pick(part2, [
              'contractId',
              'partNumber',
              'productCode',
              'productName',
              'monthlyRenewalPrice',
              'currency',
              'priceLockYearsRemaining'
            ])
          );
        };

        var aggregateMatchingParts = function(segment) {
          var index = 0;
          while (index < segment.parts.length) {
            var aggregatePart = segment.parts[index];
            var partIndicesToRemove = [];
            // iterate over the rest of the parts array (the earlier portions should already be aggregated)
            for (var i = index + 1; i < segment.parts.length; ++i) {
              // If the parts can be aggregated, and both have valid quantities and total annual prices, combine them into a single part.
              if (
                shouldPartsBeAggregated(aggregatePart, segment.parts[i]) &&
                isFinite(aggregatePart.quantity) &&
                isFinite(segment.parts[i].quantity) &&
                isFinite(aggregatePart.totalAnnualRenewalPrice) &&
                isFinite(segment.parts[i].totalAnnualRenewalPrice)
              ) {
                partIndicesToRemove.push(i);
                aggregatePart.quantity =
                  parseInt(aggregatePart.quantity, 10) + parseInt(segment.parts[i].quantity, 10);
                aggregatePart.totalAnnualRenewalPrice =
                  parseFloat(aggregatePart.totalAnnualRenewalPrice) +
                  parseFloat(segment.parts[i].totalAnnualRenewalPrice);
              }
            }
            // remove the marked indices in reverse order, so the prior items won't change index as we process removals
            for (var j = partIndicesToRemove.length - 1; j >= 0; j--) {
              segment.parts.splice(partIndicesToRemove[j], 1);
            }
            index++;
          }
        };

        /*
        * Takes the response from the quote API, which comes in the form of an array of "parts" (products)
        * and creates an object with the response array as one attribute, a total object that provides
        * the sum of license quantities and prices, and a region attribute that describes the sales region
        * to help determine what to call the MSRP in the UI.
        * */
        this.createQuoteDataObjectFromResponse = function(response) {
          var quoteData = {};

          // Next create a segment to hold the parts for each currency.
          quoteData.segments = {};

          _.forEach(response, function(part) {
            var currency = part.currency;

            if (!quoteData.segments[currency]) {
              quoteData.segments[currency] = {
                parts: []
              };
            }

            // Create a productInfo object with code and name so the name translation filter can use it.
            part.productInfo = {code: part.productCode, name: part.productName};

            quoteData.segments[currency].parts.push(part);
          });

          var totalQuantity;
          var totalMSRP;

          _.forEach(quoteData.segments, function(segment) {
            // Aggregate parts that are for the same product
            // See comment for shouldPartsBeAggregated above for matching fields
            aggregateMatchingParts(segment);

            totalQuantity = 0;
            totalMSRP = 0;

            _.forEach(segment.parts, function(part) {
              if (isFinite(part.quantity)) {
                totalQuantity += parseInt(part.quantity, 10);
              }
              if (isFinite(part.totalAnnualRenewalPrice)) {
                totalMSRP += parseFloat(part.totalAnnualRenewalPrice);
              }
            });

            // Create total object with summary info
            segment.total = {
              quantity: totalQuantity,
              msrp: totalMSRP
            };

            // Add region data to the quote object, for display of "MSRP" equivalent string based on
            // geo.
            // use the first part's sales region; they *should* all be the same
            var salesRegion = segment.parts[0].geoDescription;
            salesRegion = salesRegion ? _.toLower(salesRegion) : 'none';

            // ToDo: update based on what the "real" values are on geoDescription
            switch (salesRegion) {
              case 'americas':
                segment.customerSalesRegion = 'NA';
                break;
              case 'japan':
                segment.customerSalesRegion = 'JP';
                break;
              case 'asia':
                segment.customerSalesRegion = 'APAC';
                break;
              default:
                segment.customerSalesRegion = 'EMEA';
            }

            // For the currency filter
            var currencyCode = segment.parts[0].currency;
            segment.currencySymbol = getCurrencySymbol(currencyCode);

            // Japanese Yen does not use decimals; they only have whole number values.
            // Set up the data so that fractions are removed from the formatted currency
            // number for prices in JPY. This is currency-specific rather than locale-specific.
            segment.removeCurrencyDecimals = currencyCode === 'JPY' ? 0 : 2;
          });

          return quoteData;
        };
      }
    );
})();
